import Vue from 'vue'
import VueRouter from 'vue-router'







Vue.use(VueRouter)



const routes = [
    {
    path: '/',
    name: 'home',
    component: () => import('./app'),
    children: [
        {
            path: '/d1',
            name: 'd1',
            //component: () => import('./views/demo2/index')
        }

    ]

},
    {
        path:'/academicDegree',
        name:'academicDegree',
        component:() => import('../district/views/academicDegree')
    }

]

const router = new VueRouter({
  routes
})

export default router
